import {SpaceImage} from 'services/entities/spaces';
import {withRouter} from 'react-router';
import React from 'react';
import {ViewSpacePageBase} from './View/index';

class SpaceLandingPageBase extends ViewSpacePageBase {
  renderTourButton(): JSX.Element | null {
    return null;
  }

  renderDesignButton(): JSX.Element | null {
    return null;
  }

  renderBannerCarousel(bannerImages: SpaceImage[]): JSX.Element | null {
    return <img src={bannerImages[0].url} className="hero" alt="" />;
  }
}

export default withRouter(SpaceLandingPageBase);